import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecuritySetupAuditTrailGraph } from '@api';

export const getCoreDataSecuritySetupAuditTrailGraphSlice = createGetAsyncSlice({
	name: 'CoreDataSecuritySetupAuditTrailGraph',
	receive: true,
	request: true,
	requestHandler: getDataSecuritySetupAuditTrailGraph,
	retainDataOnRequest: true
});
